<template>
  <div>
    <v-container fluid>
      <Govem_bar />
      <base-material-card icon="mdi-view-dashboard-variant" title="ภาพรวมงานพนักงานราชการ (สถาบัน)" class="px-5 py-3">
        <v-alert type="info" outlined dense border="left" class="mb-3">
          ติดตามวงจรงานพนักงานราชการครบทุกขั้นตอน: กรอบอัตรากำลัง → ทะเบียนประวัติ/สัญญาจ้าง → การลา →
          ประเมินผล ปผ.พนร. (ปีละ 2 รอบ) → เลื่อนค่าตอบแทน → การย้าย → ลาออก/พ้นสภาพ
        </v-alert>
        <GovemLifecycleHub mode="unit" link-base="iven" />
      </base-material-card>
    </v-container>
  </div>
</template>

<script>
import Govem_bar from "../../../components/iven/govem_bar.vue";
import GovemLifecycleHub from "../../../components/govem/GovemLifecycleHub.vue";

export default {
  name: "GovemHub",
  components: { Govem_bar, GovemLifecycleHub }
};
</script>
